import { z } from 'zod';
import { FilterTypeEnum } from './filterTypes.js';

// Core interface types for client use
export interface FilterItemValue {
  key: string;
  value: string;
}

export interface FilterItem {
  id: number;
  identifier: string;
  label: string;
  type: FilterTypeEnum;
  operators: string[];
  data: FilterData;
}

// Basic Zod schemas for validation
export const FilterItemSchema = z.object({
  key: z.string(),
  value: z.string(),
});

export const DropdownFilterDataSchema = z.object({
  items: z.array(FilterItemSchema),
});

export const AutocompleteFilterDataSchema = z.object({
  endpoint: z.url(),
});

export const FilterDataSchema = z.union([DropdownFilterDataSchema, AutocompleteFilterDataSchema]);

const FilterDataSchemaMap = {
  [FilterTypeEnum.Dropdown]: DropdownFilterDataSchema,
  [FilterTypeEnum.DateRange]: DropdownFilterDataSchema,
  [FilterTypeEnum.Autocomplete]: AutocompleteFilterDataSchema,
};
export type FilterData<T extends FilterTypeEnum = FilterTypeEnum> = z.infer<typeof FilterDataSchemaMap[T]>;

export type FilterItemZod = z.infer<typeof FilterItemSchema>;
export type FilterDataZod = z.infer<typeof FilterDataSchema>;

// Utility function for parsing filter data
export function parseFilterData(data: unknown, type: FilterTypeEnum): FilterData {
  const schema = FilterDataSchemaMap[type];

  const parseResult = schema.safeParse(data);

  if (!parseResult.success) {
    return { items: [] };
  } else {
    return parseResult.data as FilterData;
  }
}
